export function MaterialSymbolsLineEndArrowNotch(props) {
    return (
        <svg className="themes__container__choice__content__color__icon" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m11 19l3.425-6H2v-2h12.425L11 5l11 7z"></path></svg>
    )
}